import { Country } from "react-addressfinder";
import { EmployerFormValuesType } from "../../components/shared/EmployerForm";
import parsePhoneNumberFromString from "libphonenumber-js";

export const updateEmployer = async (
    API_URL: string,
    token: string,
    employerId: string,
    values: EmployerFormValuesType
) => {
    const formattedPhoneNumber = parsePhoneNumberFromString(
        values.contact.phone,
        values.contact.address.country === "NZ" ? Country.NZ : Country.AU
      )?.number;

    const response = await fetch(
        `${API_URL}/employers/${employerId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...values,
            contactName:
              values.contactFirstName + " " + values.contactLastName,
            contact: {
              ...values.contact,
              contactFirstName: undefined,
              contactLastName: undefined,
              phone: formattedPhoneNumber,
              address: {
                ...values.contact.address,
                city: values.contact.address.city,
                // Only include state/province for outside of NZ
                stateOrProvince:
                  values.contact.address.country !== "NZ"
                    ? values.contact.address.stateOrProvince
                    : undefined
              }
            }
          })
        }
      );

      if (!response.ok) {
        let responseJson;
        try {
          responseJson = await response.json();
        } catch (err) {
          throw new Error("There was a problem updating your account.");
        }

        switch (response.status) {
          case 409:
            throw new Error("Email already in use. Please contact support");
          case 400:
            if (responseJson.errors["Contact.Phone"]) {
              throw new Error(responseJson.errors["Contact.Phone"][0]);
            } else if (responseJson.errors["Contact.Email"]) {
              throw new Error(responseJson.errors["Contact.Email"][0]);
            } else {
              throw new Error("There was a problem updating your account.");
            }
          default:
            throw new Error("There was a problem updating your account.");
        }
      }
}